import React from 'react';
import classes from './CostumerProfile.module.css';
import { SalesOrderInfo } from '../../../../store/slices/salesOrders';
import moment from 'moment';
import { useTranslation } from '../../../../hooks/useTranslations';

const CustomerProfile: React.FC<{ selectedSalesOrder: SalesOrderInfo }> = ({
  selectedSalesOrder,
}) => {
  const { translations } = useTranslation();
  return (
    <div className={classes.container}>
      <div className={classes.header}>
        {translations('customer.information')}
        <div className={classes.subHeader}>
          {translations('basic.info') + ' '}
          {translations('ecocare.platform')}
        </div>
      </div>
      <div className={classes.contentSectionHeader}>{translations('personal')}</div>
      <div className={classes.customerProfileRow}>
        <div className={classes.customerProfileRowText1}>{translations('full.name')}</div>
        <div className={classes.customerProfileRowText2}>
          {selectedSalesOrder.customer_person.person_firstname}{' '}
          {selectedSalesOrder.customer_person.person_lastname}
        </div>
      </div>
      <div className={classes.customerProfileRow}>
        <div className={classes.customerProfileRowText1}>{translations('email')}</div>
        <div className={classes.customerProfileRowText2}>
          {selectedSalesOrder.customer_person.person_email}
        </div>
      </div>
      <div className={classes.customerProfileRow}>
        <div className={classes.customerProfileRowText1}>{translations('phone.number')}</div>
        <div className={classes.customerProfileRowText2}>
          {selectedSalesOrder.customer_person.person_mobile_phone}
        </div>
      </div>
      <div className={classes.customerProfileRow}>
        <div className={classes.customerProfileRowText1}>{translations('date.of.birth')}</div>
        <div className={classes.customerProfileRowText2}>
          {moment(selectedSalesOrder.customer_person.person_birthdate).format('DD.MM.YYYY')}
        </div>
      </div>
      <div className={classes.customerProfileRow}>
        <div className={classes.customerProfileRowText1}>{translations('gender')}</div>
        <div className={classes.customerProfileRowText2}>{selectedSalesOrder.gender.gender}</div>
      </div>
      <div className={classes.contentSectionHeader}>{translations('health.profile')}</div>
      <div className={classes.customerProfileRow}>
        <div className={classes.customerProfileRowText1}>{translations('blood.type')}</div>
        <div className={classes.customerProfileRowText2}></div>
      </div>
      <div className={classes.customerProfileRow}>
        <div className={classes.customerProfileRowText1}>{translations('height')}</div>
        <div className={classes.customerProfileRowText2}></div>
      </div>
      <div className={classes.customerProfileRow}>
        <div className={classes.customerProfileRowText1}>{translations('weight')}</div>
        <div className={classes.customerProfileRowText2}></div>
      </div>
      <div className={classes.customerProfileRow}>
        <div className={classes.customerProfileRowText1}>{translations('allergic')}</div>
        <div className={classes.customerProfileRowText2}></div>
      </div>
    </div>
  );
};

export { CustomerProfile };
